import {captureException} from "@sentry/react";
import {PolIcon} from "components/PolIcon/policon";
import React, {useMemo} from 'react';
import {Droppable} from "react-beautiful-dnd";
import {useFormContext} from "react-hook-form";
import ReactTooltip from "react-tooltip";
import LineRow
    from "v4/features/front/products/components/QuotesProductsDetails/components/QuotesProductsTable/components/QuotesProductsTableSection/components/LineRow/LineRow";
import SectionSubTotal
    from "v4/features/front/products/components/QuotesProductsDetails/components/QuotesProductsTable/components/QuotesProductsTableSection/components/SectionSubTotal/SectionSubTotal";
import {
    useQuotesProductsDetailsContext
} from "v4/features/front/products/components/QuotesProductsDetails/contexts/QuotesProductsDetailsContext/QuotesProductsDetailsContext";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function QuotesProductsTableSection({
                                                       isShow,
                                                       name,
                                                       id,
                                                       sectionIndex,
                                                       isDefault,
                                                       editAttributesFor,
                                                   }) {
    const {t} = usePolTranslation();
    const {
        quoteLinesMethods: {fields, remove, update},
        sectionsNames,
        updateSectionName,
        removeSection,
        properties,
        formMetadata,
    } = useQuotesProductsDetailsContext();

    const {getValues} = useFormContext();

    const updateQuoteLineSection = (index, sectionName) => {
        const nextLine = {
            ...getValues(`quoteLines.${index}`),
            sectionName,
        };
        update(index, nextLine);
    }

    const onlyCurrentSection = ({sectionName}) => {
        return sectionName === name || (!sectionName && isDefault);
    }

    const editSectionName = e => {
        const {value} = e.target;
        updateSectionName(sectionIndex, id, value);
        fields.filter(onlyCurrentSection).forEach((field) => {
            const fieldIndex = fields.indexOf(field);
            updateQuoteLineSection(fieldIndex, `${sectionIndex}|${value}|${id}`);
        });
    }

    const removeCurrentSection = () => {
        removeSection(id);
        fields.filter(onlyCurrentSection).forEach((field) => {
            const fieldIndex = fields.indexOf(field);
            const nextLine = {
                ...getValues(`quoteLines.${fieldIndex}`),
                sectionName: '',
            };
            update(fieldIndex, nextLine);
        });
    }

    const indexById = useMemo(() => new Map(fields.map((f, i) => [f.id, i])), [fields]);

    return (
        <div className="quotes-products__tbody__section">
            {
                isShow
                    ? (
                        <h3>
                            <span>{isDefault ? t('without_section') : name.split('|')[1]}</span>
                        </h3>
                    )
                    : (
                        <div className="quotes-products__tbody__section__heading">
                            <input type="text"
                                   value={name.split('|')[1] ?? ''}
                                   list="quoteSections"
                                   onChange={editSectionName}
                                   placeholder={isDefault ? t('without_section') : t('new_section')}/>
                            {!isDefault && (
                                <>
                                    <button type="button"
                                            data-tip={`${t('delete')} ${(name.split('|')[1]) ?? ''}`}
                                            data-for={`delete-${id}`}
                                            onClick={removeCurrentSection}>
                                        <PolIcon icon="minus"/>
                                    </button>
                                    <ReactTooltip id={`delete-${id}`} effect="solid"/>
                                </>
                            )}
                        </div>
                    )
            }
            <Droppable key={id} droppableId={id}>
                {(provided) => {
                    return (
                        <div className="quotes-products__tbody__droppable"
                             ref={provided.innerRef} {...provided.droppableProps}>
                            {
                                fields.filter(onlyCurrentSection).map((field, index) => {
                                    const realIndex = indexById.get(field.id);

                                    if (realIndex === undefined) {
                                        captureException(new Error("QuotesProductsTableSection: ligne absente de l'index useFieldArray"), {
                                            extra: {fieldId: field.id, sectionName: name, fieldsCount: fields.length},
                                        });
                                        return null;
                                    }

                                    return <LineRow key={field.id}
                                                    field={field}
                                                    index={index}
                                                    realIndex={realIndex}
                                                    isShow={isShow}
                                                    editAttributesFor={editAttributesFor}
                                                    remove={remove}
                                                    properties={properties}
                                                    formMetadata={formMetadata}/>
                                })
                            }
                            {provided.placeholder}
                        </div>
                    )
                }}
            </Droppable>
            {
                sectionsNames.length > 1 && <SectionSubTotal name={name}/>
            }
        </div>
    )
}
